import { render, staticRenderFns } from "./guihua.vue?vue&type=template&id=dad19a6c&"
import script from "./guihua.vue?vue&type=script&lang=js&"
export * from "./guihua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports